import React, { ComponentProps } from 'react'
import { Tag, TAG_SIZE, TAG_STYLE } from 'transfix-ui/components/Tag'
import { IConfigurableBuilderTestResultStatuses } from 'types/graphqlTypes'
import { CheckOutlineIcon, CloseIcon } from 'transfix-icons'

interface ITestResultTagProps {
  status?: IConfigurableBuilderTestResultStatuses
}

const TAG_PROPS: Record<
  IConfigurableBuilderTestResultStatuses | 'default',
  Pick<ComponentProps<typeof Tag>, 'label' | 'icon' | 'tagStyle'>
> = {
  [IConfigurableBuilderTestResultStatuses.PASSED]: {
    label: 'Passed',
    icon: <CheckOutlineIcon size='small' />,
    tagStyle: TAG_STYLE.success,
  },
  [IConfigurableBuilderTestResultStatuses.FAILED]: {
    label: 'Failed',
    icon: <CloseIcon size='small' />,
    tagStyle: TAG_STYLE.error,
  },
  [IConfigurableBuilderTestResultStatuses.SKIPPED]: {
    label: 'Skipped',
    icon: <CheckOutlineIcon size='small' />,
    tagStyle: TAG_STYLE.info,
  },
  default: {
    label: 'Not Run',
    icon: <CloseIcon size='small' />,
    tagStyle: TAG_STYLE.disabled,
  },
}

export const TestResultTag = ({ status }: ITestResultTagProps) => {
  const { icon, label, tagStyle } = status === undefined ? TAG_PROPS.default : TAG_PROPS[status]

  return <Tag label={label} icon={icon} size={TAG_SIZE.small} tagStyle={tagStyle} />
}
